import React from 'react';

import {markAsSafe} from 'app/utils/strings';

import {StyledImageListUL} from './EditableStepImagesGallery';

import type {AttachedEmbed} from 'sweet-types';

type Props = {
  embeds: Array<AttachedEmbed>;
  onRemove: (image: AttachedEmbed, index: number) => void;
};

export function EditableStepEmbedsGallery({
  embeds,
  onRemove,
}: Props): JSX.Element | null {
  if (embeds.length === 0) {
    return null;
  }

  return (
    <div>
      <StyledImageListUL>
        {embeds.map((embed, index) => {
          return (
            <li key={index} className="image col-12 col-sm-6 col-lg-3 mb-4">
              <div className="bg-secondary border border-secondary d-flex justify-content-center align-items-center">
                <div
                  dangerouslySetInnerHTML={markAsSafe(
                    setIframeDimensions(embed.embed_html, '100%', '100%')
                  )}
                />
              </div>
              <button
                className="btn btn-link delete-img"
                onClick={() => onRemove(embed, index)}
              >
                <i className="fa fa-times" />
              </button>
            </li>
          );
        })}
      </StyledImageListUL>
    </div>
  );
}

const setIframeDimensions = (
  html: string,
  width: string,
  height: string
): string => {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const iframe = temp.querySelector('iframe');
  if (iframe) {
    iframe.width = width;
    iframe.height = height;
  }
  return temp.innerHTML;
};
